import { gql } from 'apollo-angular';

export const InputDeleteByRefNrDocument = gql`
  mutation inputDeleteByRefNr($refNr: String!) {
    inputDeleteByRefNr(refNr: $refNr)
  }
`;
